import { useEffect, useState } from 'react';

import isBrowser from '@/helpers/isBrowser';

/**
 * Returns true when the device supports hover interactions (has a pointing device like a mouse).
 * Returns false for touch-only devices where hover is not supported.
 * Uses the CSS media query `(hover: hover)` to detect hover capability.
 */
function useSupportsHover(): boolean {
  const [supportsHover, setSupportsHover] = useState<boolean>(() => {
    if (!isBrowser()) return true;
    return !!document.defaultView?.matchMedia('(hover: hover)').matches;
  });

  useEffect(() => {
    if (!isBrowser()) {
      return undefined;
    }

    const mediaQuery = document.defaultView?.matchMedia('(hover: hover)');

    setSupportsHover(!!mediaQuery?.matches);

    const handler = (event: MediaQueryListEvent): void => {
      setSupportsHover(event.matches);
    };

    mediaQuery?.addEventListener('change', handler);

    return () => {
      mediaQuery?.removeEventListener('change', handler);
    };
  }, []);

  return supportsHover;
}

export default useSupportsHover;
